// extracted by mini-css-extract-plugin
module.exports = {"checkboxInputRow":"n_qb","checkboxInputColumn":"n_qc","inputOptionRow":"n_p1","inputOptionColumn":"n_p2"};